(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tec-promo-popup')) {
    customElements.define('tec-promo-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.pending = false;
        this.imageReady = this.querySelector('img').decode().then(() => true, () => false);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.key = `tec-promo-popup:${this.dataset.sectionId}`;
        this.querySelector('button').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('click', (event) => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.close();
        }, options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, options);
        if (this.hasAttribute('data-editor')) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          }, options);
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.close();
          }, options);
          return;
        }
        try {
          if (this.dataset.frequency === 'session' && sessionStorage.getItem(this.key)) return;
        } catch (_) { /* Storage can be unavailable in private browsing. */ }
        const start = () => {
          if (this.dataset.trigger !== 'scroll') this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          if (this.dataset.trigger !== 'delay') {
            this.onScroll = () => {
              const distance = document.documentElement.scrollHeight - window.innerHeight;
              if (distance > 0 && window.scrollY / distance * 100 >= Number(this.dataset.scroll)) this.open();
            };
            window.addEventListener('scroll', this.onScroll, { passive: true, ...options });
            this.onScroll();
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, ...options });
        else start();
      }
      async open() {
        if (!this.isConnected || this.dialog.open || this.pending) return;
        if (this.shown && !this.hasAttribute('data-editor')) return;
        this.pending = true;
        clearTimeout(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        const ready = await this.imageReady;
        if (!this.pending || !this.isConnected) return;
        this.pending = false;
        if (!ready) return;
        this.shown = true;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        if (!this.hasAttribute('data-editor') && this.dataset.frequency === 'session') {
          try { sessionStorage.setItem(this.key, '1'); } catch (_) {}
        }
      }
      close() {
        this.pending = false;
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.dialog.close();
          return;
        }
        this.dialog.classList.add('is-closing');
        this.closeTimer = setTimeout(() => this.dialog.close(), 220);
      }
      disconnectedCallback() {
        this.pending = false;
        clearTimeout(this.closeTimer);
        clearTimeout(this.timer);
        this.controller.abort();
        this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-scroll"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="testi-scroller-"]').forEach((scroller) => {
    scroller.querySelectorAll('.tec-video-cards').forEach((grid) => {
      let slide = grid;
      while (slide.parentElement && slide.parentElement !== scroller) {
        slide = slide.parentElement;
      }
      if (slide.parentElement === scroller) {
        slide.classList.add('tec-testimonial-video-slide');
      }
    });

    const id = scroller.id.replace('testi-scroller-', '');
    const dotsWrap = document.getElementById('testi-dots-' + id);
    const cards = Array.from(scroller.children);
    if (!cards.length) return;

    if (dotsWrap) {
      const dots = Array.from(dotsWrap.querySelectorAll('[role="tab"]'));
      const setActive = (index) => {
        dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index, 10);
          cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(cards.indexOf(entry.target));
        });
      }, { root: scroller, threshold: 0.6 });

      cards.forEach((card) => observer.observe(card));
      setActive(0);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
